import { Box, BoxProps, Loader, successIcon } from '@ytl/common-web';

import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';
import { LoginView } from '../shared/@types/OpenAmStage';
import { DeviceCodeStage } from './DeviceCodeStage';

export const LoginDeviceCode = () => {
  const { stage, error } = useOpenAm();
  const { translation } = useLanguage();

  const view = stage.view;

  const boxConfig = {
    ...successIcon,
    header: translation.loginRegister.login.device.success.header,
    subHeader: translation.loginRegister.login.device.success.subHeader,
    className: 'box__devicecode',
  } as BoxProps;
  return (
    <>
      <div className="login-page__wrapper">
        <div className="login-page__container login-page__container--center">
          <div className={`login-page__container__box ${error ? 'login-page__container__box--error-view' : ''}`}>
            {
              <>
                {view === LoginView.Loader && (
                  <div className="login-page__container__page-loader">
                    <Loader isLoading={true} />
                  </div>
                )}

                {view === LoginView.DeviceCode && <DeviceCodeStage />}

                {view === LoginView.DeviceCodeSuccess && <Box {...boxConfig} />}
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};
